import React, { useEffect } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import FooterBangla from "../../components/componentsBangla/FooterBangla";
import HeaderOthersBangla from "../../components/componentsBangla/HeaderOthersBangla";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "60px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
  },
  content: {
    fontSize: "1rem",
    marginBottom: "20px !important",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px !important",
    fontWeight: "500 !important",
  },

  icon: {
    marginRight: 10,
    position: "relative",
    top: 5,
  },
  select: {
    marginBottom: 30,
  },
  footer: {
    marginTop: "-80px",
  },
}));

const FaqBangla = () => {
  const classes = useStyle();

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    window.scrollTo(0, -1);
  }, []);

  return (
    <>
      <HeaderOthersBangla title="সাধারণ জিজ্ঞাসা" customLink="FAQs" />
      <div className={classes.root}>
        <Container maxWidth="lg" style={{ marginBottom: "110px" }}>
          <Grid container spacing={2}>
            <Grid item md={12} style={{ width: "100%" }}>
              <h4>এসটি পে সম্পর্কিত সাধারণ জিজ্ঞাসা</h4>
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography>এসটি পে সম্পর্কে</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এসটি পে (ST Pay) গ্রীণ এন্ড রেড টেকনলোজিস লিমিটেড (Green and
                    Red Technologies Limited)-এর একটি ই-ওয়ালেট অ্যাপ্লিকেশন
                    যেটা iOS এবং Android দুই প্ল্যাটফর্মেই উপলব্ধ। বাংলাদেশ
                    ব্যাংক কর্তৃক পেমেন্ট সার্ভিস প্রোভাইডার (PSP) হিসাবে
                    লাইসেন্সপ্রাপ্ত গ্রীণ এন্ড রেড টেকনলোজিস-এর সার্ভিসটি
                    জনসাধারণের জন্য স্মার্ট ফোন, ট্যাব ডিভাইস এবং ওয়েব সংস্করণে
                    রয়েছে। অ্যাপটির উদ্দেশ্য হল সমাজকে ক্যাশলেস রাখা, জীবনকে আরও
                    সহজ করে তোলা এবং ডিজিটাল বিশ্বে নির্বিঘ্ন এবং সুরক্ষিত একটি
                    লাইফস্টাইল সেবা বাস্তবায়ন করা।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content2"
                  id="panel1bh-header2"
                >
                  <Typography>এসটি পে কি কি সেবা প্রদান করে?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ul>
                    <li>
                      <Typography variant="body2">সেন্ড মানি</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">রিসিভ মানি</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">অ্যাড মানি</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        ট্রান্সফার টু ব্যাংক
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">রিকোয়েস্ট মানি</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">মোবাইল রিচার্জ</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">বিল পেমেন্ট</Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        স্ক্যান অ্যান্ড পে
                      </Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content3"
                  id="panel1bh-header3"
                >
                  <Typography>
                    একজন ব্যক্তি কিভাবে এসটি পে ডাউনলোড করতে পারবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    অ্যান্ড্রয়েড ব্যবহারকারীর জন্য:
                  </Typography>
                  <ol>
                    <li>
                      <Typography variant="body2">
                        গুগল প্লে স্টোর থেকে অ্যান্ড্রয়েড কনজিউমার অ্যাপটি
                        ডাউনলোড করুন।
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        গুগল প্লে স্টোর থেকে অ্যান্ড্রয়েড মার্চেন্ট অ্যাপটি
                        ডাউনলোড করুন।
                      </Typography>
                    </li>
                  </ol>
                  <Typography variant="body2">
                    IOS ব্যবহারকারীর জন্য:
                  </Typography>
                  <ol>
                    <li>
                      <Typography variant="body2">
                        অ্যাপল অ্যাপ স্টোর থেকে IOS কনজিউমার অ্যাপটি ডাউনলোড
                        করুন।
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        অ্যাপল অ্যাপ স্টোর থেকে IOS মার্চেন্ট অ্যাপটি ডাউনলোড
                        করুন।
                      </Typography>
                    </li>
                  </ol>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content4"
                  id="panel1bh-header4"
                >
                  <Typography>
                    এসটি পেতে কত ধরনের অ্যাকাউন্ট পাওয়া যায়?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এসটি পেতে দুই ধরনের একাউন্ট রয়েছে
                  </Typography>
                  <ol>
                    <li>
                      <Typography variant="body2">
                        ব্যক্তিগত বা কনজিউমার অ্যাকাউন্ট{" "}
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        মার্চেন্ট অ্যাকাউন্ট
                      </Typography>
                    </li>
                  </ol>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel5"}
                onChange={handleChange("panel5")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content5"
                  id="panel1bh-header5"
                >
                  <Typography>
                    কীভাবে একটি এসটি পে ব্যক্তিগত অ্যাকাউন্ট তৈরি করবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <h4>সহজেই আপনার এসটি পে অ্যাকাউন্ট খুলুন</h4>
                    <p>
                      এসটি পে ব্যবহার শুরু করা খুবই সহজ এবং সুবিধাজনক! এখন আপনি যেকোনো সময়, যেকোনো জায়গা থেকে আপনার মোবাইল ফোন ব্যবহার করে সহজেই নতুন এসটি পে অ্যাকাউন্ট খুলতে পারেন। বর্তমানে Airtel, Banglalink, Teletalk, Grameenphone এবং Robi নম্বর দিয়ে রেজিস্ট্রেশন করা যাচ্ছে।
                    </p>

                    <h4>যা যা প্রয়োজন হবে:</h4>
                    <ul>
                      <li>একটি মোবাইল ফোন</li>
                      <li>আপনার আসল জাতীয় পরিচয়পত্র (NID)</li>
                    </ul>

                    <h4>এসটি পে অ্যাপের মাধ্যমে রেজিস্ট্রেশন করার ধাপসমূহ:</h4>
                    <ol>
                      <li>এসটি পে অ্যাপ খুলে “Login/Register” এ ট্যাপ করুন।</li>
                      <li>আপনার মোবাইল নম্বর লিখুন।</li>
                      <li>SMS এর মাধ্যমে পাঠানো কোড দিয়ে নম্বর ভেরিফাই করুন।</li>
                      <li>৪ সংখ্যার একটি পিন(PIN) তৈরি করুন এবং নিশ্চিত করুন।</li>
                      <li>শর্তাবলী গ্রহণ করে এগিয়ে যান।</li>
                      <li>আপনার জাতীয় পরিচয়পত্রের সামনে ও পিছনের স্পষ্ট ছবি আপলোড করুন।</li>
                      <li>অটো-ফিল করা তথ্যগুলো পর্যালোচনা করে নিশ্চিত করুন।</li>
                      <li>আপনার ফোনের ক্যামেরা দিয়ে একটি সেলফি তুলুন।</li>
                      <li>সব তথ্য সাবমিট করে ভেরিফিকেশনের জন্য অপেক্ষা করুন।</li>
                      <li>ভেরিফিকেশন সম্পন্ন হতে সর্বোচ্চ ৭২ ঘণ্টা পর্যন্ত সময় লাগতে পারে।</li>
                      <li>অনুমোদন পাওয়ার পর এসটি পে অ্যাপে লগইন করে আপনার অ্যাকাউন্ট ব্যবহার শুরু করুন।</li>
                    </ol>

                    <h4 style={{ marginTop: "30px" }}>সবসময় আপনার পিন(PIN) গোপন রাখুন এবং কারো সাথে শেয়ার করবেন না।</h4>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel6"}
                onChange={handleChange("panel6")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content6"
                  id="panel1bh-header6"
                >
                  <Typography>
                    কিভাবে একটি এসটি পে মার্চেন্ট অ্যাকাউন্ট তৈরি করবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এসটি পে মার্চেন্ট অ্যাকাউন্ট তৈরি করতে অনুগ্রহ করে সাপোর্ট টিমের সাথে যোগাযোগ করুন। আপনি ইমেইল পাঠাতে পারেন <a href="mailto:support@stpay.net" style={{ color: "#3d96ff" }}>support@stpay.net</a>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel7"}
                onChange={handleChange("panel7")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content7"
                  id="panel1bh-header7"
                >
                  <Typography>কিভাবে এসটি পেতে লগ ইন করবেন?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আপনি যে পিন সেট করেছেন তা ব্যবহার করে আপনার এসটি পে
                    একাউন্টে লগ ইন করতে পারবেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel8"}
                onChange={handleChange("panel8")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content8"
                  id="panel1bh-header8"
                >
                  <Typography>
                    এসটি পে সেবা প্রাপ্তির জন্য কারা যোগ্য?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    যেকোনো ব্যক্তি যার বৈধ জাতীয় পরিচয়পত্র (এনআইডি/NID), ফোন নম্বর এবং ব্যাংক অ্যাকাউন্ট আছে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              
              <h4>গ্রাহক সেবা</h4>
              
              <Accordion
                expanded={expanded === "panel10"}
                onChange={handleChange("panel10")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    আমি কিভাবে আমার এসটি পে অ্যাকাউন্টে টাকা অ্যাড করব?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          অ্যাড মানিতে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          কার্ড/এমএফএস/ব্যাংক অপশনে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          আপনি যে পরিমাণ টাকা এসটি পেতে অ্যাড করতে চান সেই
                          এমাউন্ট লিখুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          তারপরে “পেমেন্ট ডিটেইলস” নামে একটি পৃষ্ঠা দেখা যাবে
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          কার্ড/এমএফএস/ব্যাংক টাইপে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          কার্ড/এমএফএস/ব্যাংক নম্বর এবং সে সম্পর্কিত অন্যান্য সঠিক তথ্য টাইপ
                          করুন এবং “পে”-তে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          তারপরে আপনি টাকা অ্যাড করা হয়েছে কিনা তা পরীক্ষা করতে
                          ট্যাপ টু ব্যালেন্সে ট্যাপ করুন।
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Send Money */}
              <Accordion
                expanded={expanded === "panel11"}
                onChange={handleChange("panel11")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content11"
                  id="panel1bh-header11"
                >
                  <Typography>
                    আপনি কিভাবে এসটি পে থেকে টাকা পাঠাবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          “সেন্ড মানি”-তে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          আপনি যে ফোন নম্বরে টাকা পাঠাতে চান সেই নাম্বারটি টাইপ
                          করুন বা ফোন লগ থেকে নির্বাচন করুন।
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          আপনি যে পরিমাণ টাকা পাঠাতে চান তা টাইপ করুন।
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          এসটি পে পিন নাম্বারটি প্রদান করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          তারপর “নেক্সট”-এ ক্লিক করুন
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* ব্যাংক উপকারভোগী */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary"}
                onChange={handleChange("panelBankBeneficiary")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    কেন আমাকে একটি ব্যাংক উপকারভোগী যোগ করতে হবে?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    সহজ লেনদেন নিশ্চিত করতে এবং আপনার মাসিক লেনদেন সীমা বাড়াতে
                    এটি প্রয়োজন। ব্যাংক অ্যাকাউন্ট না যোগ করলে আপনার মাসিক
                    লেনদেন সীমা টাকা ১০,০০০ এ সীমাবদ্ধ থাকবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* ব্যাংক উপকারভোগী - কিভাবে */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-how"}
                onChange={handleChange("panelBankBeneficiary-how")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    আমি কীভাবে একটি ব্যাংক উপকারভোগী যোগ করতে পারি?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    আপনার ব্যাংক অ্যাকাউন্ট যোগ করতে এই পদক্ষেপগুলি অনুসরণ করুন:
                    <ul>
                      <li>
                        <Typography variant="body2">
                          বিস্তারিত → ব্যাঙ্ক সুবিধাভোগী তে যান
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          আপনার ব্যাংক নাম নির্বাচন করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          আপনার শাখার নাম এবং অ্যাকাউন্ট নম্বর লিখুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          সাবমিট ক্লিক করুন
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* ব্যাংক উপকারভোগী - কি হবে */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-happen"}
                onChange={handleChange("panelBankBeneficiary-happen")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>ব্যাংক উপকারভোগী যোগ করার পর কি হবে?</Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    একবার আপনি আপনার ব্যাংক অ্যাকাউন্ট যোগ এবং যাচাই করলে, আপনার
                    লেনদেন সীমা টাকা ১০,০০০ থেকে টাকা ৪,০০,০০০ তে বৃদ্ধি পাবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* ব্যাংক উপকারভোগী - কত সময় */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-long"}
                onChange={handleChange("panelBankBeneficiary-long")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    এসটি পে একটি ব্যাংক অ্যাকাউন্ট যাচাই করতে কত সময় নেয়?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    একবার আপনি আপনার ব্যাংক অ্যাকাউন্টের বিস্তারিত জমা দিলে
                    আমাদের টিম ৩-৫ কর্মদিবসের মধ্যে আপনার অ্যাকাউন্ট যাচাই করবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* ব্যাংক উপকারভোগী - কিভাবে যাচাই করা হয় */}
              <Accordion
                expanded={expanded === "panelBankBeneficiary-d"}
                onChange={handleChange("panelBankBeneficiary-d")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content10"
                  id="panel1bh-header10"
                >
                  <Typography>
                    এসটি পে কীভাবে একজন ব্যবহারকারীর ব্যাংক অ্যাকাউন্ট যাচাই
                    করে?
                  </Typography>
                </AccordionSummary>

                <AccordionDetails>
                  <Typography variant="body2">
                    আমরা আপনার প্রদত্ত ব্যাংক অ্যাকাউন্টে একটি ছোট পরিমাণ পাঠাই
                    যাচাই প্রক্রিয়ার অংশ হিসেবে। আপনি পরে অ্যাপের নির্দিষ্ট
                    জায়গায় প্রাপ্ত সঠিক পরিমাণটি লিখবেন। যদি সিস্টেমটি ইনপুটটি
                    মিলিয়ে দেয়, তবে আপনার অ্যাকাউন্ট যাচাই করা হবে এবং আপনি
                    সর্বোচ্চ মাসিক লেনদেন সীমা উন্মুক্ত করবেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel12"}
                onChange={handleChange("panel12")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content12"
                  id="panel1bh-header12"
                >
                  <Typography>
                    কিভাবে এসটি পে -এর মাধ্যমে পেমেন্ট করবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          পেমেন্ট আইকনে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          মার্চেন্ট অ্যাকাউন্ট নম্বরটি টাইপ করুন বা কিউআর কোড
                          স্ক্যান করুন এবং পেমেন্ট করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          এসটি পে পিন প্রদান করুন এবং “নিশ্চিত করুন”-এ ক্লিক
                          করুন
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel13"}
                onChange={handleChange("panel13")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content13"
                  id="panel1bh-header13"
                >
                  <Typography>
                    এসটি পে থেকে কি টাকা তোলা/ট্রান্সফার করা সম্ভব?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এসটি পে অ্যাকাউন্ট থেকে টাকা তোলা/ট্র্যান্সফার করা একেবারে
                    সম্ভব।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel14"}
                onChange={handleChange("panel14")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content14"
                  id="panel1bh-header14"
                >
                  <Typography>
                    কিভাবে এসটি পের মাধ্যমে অর্থ স্থানান্তর করবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <ul>
                      <li>
                        <Typography variant="body2">
                          ট্রান্সফারে ক্লিক করুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          “ব্যাংক”-এ ক্লিক করুন এবং আপনার এসটি পে অ্যাকাউন্টে
                          যোগ করা টাকা আপনি যে ব্যাংকটিতে স্থানান্তর করতে চান তা
                          বেছে নিন। যদি আগে থেকেই কোনো ব্যাংক অ্যাকাউন্ট যোগ করা
                          না থাকে তাহলে প্রথমে একটি ব্যাংক অ্যাকাউন্ট যোগ করে
                          নিন।
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          টাকার পরিমাণ এবং পিন নাম্বারটি লিখুন
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="body2">
                          তারপর ট্রান্সফার শুরু করতে “নিশ্চিত করুন”-এ ক্লিক
                          করুন।
                        </Typography>
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel15"}
                onChange={handleChange("panel15")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content15"
                  id="panel1bh-header15"
                >
                  <Typography>
                    এসটি পে থেকে অন্য ব্যাংক অ্যাকাউন্টে অর্থ স্থানান্তর করতে
                    কতক্ষণ সময় লাগে?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এক ব্যাংক থেকে অন্য ব্যাংক অ্যাকাউন্টে টাকা ট্রান্সফার করতে
                    ন্যূনতম ৪৮-৭২ ঘন্টা সময় লাগে।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel17"}
                onChange={handleChange("panel17")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content17"
                  id="panel1bh-header17"
                >
                  <Typography>
                    আমি কি কোনো লেনদেনের পরে নোটিফিকেশন পাব?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    সমস্ত নোটিফিকেশন অ্যাপটিতে সংরক্ষিত অবস্থায় থাকে যা আপনি
                    অ্যাপটির উপরের ডানদিকে (বেলের মতো আইকন) পাবেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel18"}
                onChange={handleChange("panel18")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content18"
                  id="panel1bh-header18"
                >
                  <Typography>
                    আমি কিভাবে আমার আগের লেনদেনের ইতিহাস দেখতে পারি?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আপনি প্রধান মেনুর নিচের দিকে লেনদেন নামের অপশনটিতে ক্লিক করে
                    এসটি পে অ্যাপ থেকে আপনার আগের লেনদেনের ইতিহাস দেখতে পারেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel19"}
                onChange={handleChange("panel19")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content19"
                  id="panel1bh-header19"
                >
                  <Typography>
                    এসটি পেতে টাকা যোগ করার জন্য কি কোন চার্জ প্রযোজ্য?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    অ্যাড-মানিতে কোনো চার্জ লাগবে না।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              
              
              <Accordion
                expanded={expanded === "panel22"}
                onChange={handleChange("panel22")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content22"
                  id="panel1bh-header22"
                >
                  <Typography>
                    এসটি পেতে কি একাধিক ব্যাংক অ্যাকাউন্ট সংযোগ করা সম্ভব?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    হ্যাঁ একাধিক ব্যাংক অ্যাকাউন্ট সংযোগ করা সম্ভব।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel23"}
                onChange={handleChange("panel23")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content23"
                  id="panel1bh-header23"
                >
                  <Typography>
                    আমি কি ভিসা, মাস্টারকার্ড ও আমেক্স থেকে টাকা যোগ করতে পারি?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    হ্যাঁ, আপনি ভিসা, মাস্টারকার্ড ও আমেক্স ডেবিট বা ক্রেডিট কার্ড ব্যবহার করে টাকা যোগ করতে পারেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel24"}
                onChange={handleChange("panel24")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content24"
                  id="panel1bh-header24"
                >
                  <Typography>
                    অন্য MFS (বিকাশ, নগদ, রকেট, উপায়) বা ওয়ালেটে (ipay, dmoney,
                    cashbaba) কি টাকা পাঠানো সম্ভব?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এই মুহূর্তে এই লেনদেন গুলো উপলব্ধ নেই।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              
              <Accordion
                expanded={expanded === "panel26"}
                onChange={handleChange("panel26")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content26"
                  id="panel1bh-header26"
                >
                  <Typography>
                    অ্যাপ থেকে সর্বশেষ আপডেট কিভাবে জানবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    প্রতিবার অ্যাপ আপডেট হলেই আপনাকে সর্বদা জানানো হবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel28"}
                onChange={handleChange("panel28")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content28"
                  id="panel1bh-header28"
                >
                  <Typography>আমি কি এটিএম থেকে টাকা তুলতে পারি?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    বর্তমানে আমরা কোনো এটিএম থেকে আপনার এসটি পে ব্যালেন্স তোলার
                    জন্য এই সেবাটি দিতে পারছি না।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel29"}
                onChange={handleChange("panel29")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content29"
                  id="panel1bh-header29"
                >
                  <Typography>
                    আমি কি ডেবিট বা ক্রেডিট কার্ড ব্যবহার করে এসটি পে তে টাকা
                    যোগ করতে পারি?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    অবশ্যই, আপনি সহজেই সমর্থিত ডেবিট ও ক্রেডিট কার্ড ব্যবহার করে
                    আপনার এসটি পে ওয়ালেটে টাকা যোগ করতে পারেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel100"}
                onChange={handleChange("panel100")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-panel100"
                  id="panel1bh-header100"
                >
                  <Typography>
                    আমার কার্ড থেকে টাকা কেটে নেওয়া হয়েছে কিন্তু এসটি পে
                    ওয়ালেট ব্যালেন্স আপডেট হয়নি। আমি কি করতে পারি?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    কখনও কখনও গেটওয়ে, ব্যাংক বা কার্ড প্রসেসরদের জন্য লেনদেন
                    নিশ্চিত হতে কয়েক মিনিট সময় লাগে। যদি আপনার কার্ড থেকে টাকা
                    কেটে নেওয়া হয়ে থাকে, তাহলে সাধারণত আপনার এসটি পে ওয়ালেট
                    ব্যালেন্স স্বয়ংক্রিয়ভাবে কিছু সময়ের মধ্যে আপডেট হয়ে
                    যাবে।
                  </Typography>
                  <Typography variant="body2" style={{ marginBlock: "20px 5px" }}>
                    নির্দিষ্ট সময়ের মধ্যেও যদি ব্যালেন্স আপডেট না হয়, তাহলে আমাদের সাপোর্ট টিম বিষয়টি যাচাই করে ব্যালেন্স আপডেট সম্পন্ন করবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panel30"}
                onChange={handleChange("panel30")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content30"
                  id="panel1bh-header30"
                >
                  <Typography>অভিযোগ করার পদ্ধতি কি?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    গ্রাহক একাধিক উপায়ে অভিযোগ করতে পারেনঃ
                  </Typography>
                  <ul>
                    <li>
                      <Typography variant="body2">
                        আপনি সরাসরি আমাদের সাথে যোগাযোগ করতে পারেন আমাদের
                        হেল্পলাইন: +৮৮০৯৬১৭৩৪৩৪৩৪।<br />
                        (কর্মদিবসে সকাল ৯ টা থেকে
                        সন্ধ্যা ৬ টা পর্যন্ত)
                      </Typography>
                    </li>
                    <li>
                      <Typography variant="body2">
                        আপনি support@stpay.net-এ আমাদের সরাসরি ইমেল করতে পারেন।
                      </Typography>
                    </li>
                  </ul>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel31"}
                onChange={handleChange("panel31")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content31"
                  id="panel1bh-header31"
                >
                  <Typography>
                    যদি আমি আমার মোবাইল সেট পরিবর্তন করি, আমাকে কি আবার নিবন্ধন
                    করতে হবে?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আবার নিবন্ধন করতে হবে না। একটি নতুন ডিভাইস থেকে লগইন করার
                    সাথে সাথে আপনি আপনার এসটি পে নাম্বারে একটি OTP পাবেন।
                    সফলভাবে OTP যাচাই করে আপনি নতুন ডিভাইসে এসটি পে পুনরায়
                    ব্যাবহার করতে পারবেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              
              <Accordion
                expanded={expanded === "panel35"}
                onChange={handleChange("panel35")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content35"
                  id="panel1bh-header35"
                >
                  <Typography>
                    আমি পেমেন্ট প্রক্রিয়া সম্পূর্ণ করতে না পারলে আমার কী করা
                    উচিত?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আপনি কেবল পুনরায় লগইন করতে পারেন এবং প্রক্রিয়াটি আবারও
                    করতে পারেন বা তারপরও আপনার প্রক্রিয়াটি সম্পূর্ণ না হলে আপনি
                    আমাদের হেল্পলাইনে কল করুন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel36"}
                onChange={handleChange("panel36")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content36"
                  id="panel1bh-header36"
                >
                  <Typography>
                    আমি যদি লেনদেন পরে কোনো নিশ্চিতকরণ বিজ্ঞপ্তি না পাই তাহলে
                    আমি কি করব?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    যখনই আপনি এই সমস্যার সম্মুখীন হবেন, অনুগ্রহ করে আমাদের
                    হেল্পলাইনে যোগাযোগ করুন বা আপনি আমাদের মেইল আইডি-তে একটি
                    ইমেলও পাঠাতে পারেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel37"}
                onChange={handleChange("panel37")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content37"
                  id="panel1bh-header37"
                >
                  <Typography>এসটি পে হেল্পলাইনের নম্বর কি?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আমাদের হটলাইন নম্বর +৮৮০৯৬১৭৩৪৩৪৩৪ ।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel38"}
                onChange={handleChange("panel38")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content38"
                  id="panel1bh-header38"
                >
                  <Typography>
                    ব্যক্তিগত অ্যাপের জন্য লেনদেনের সীমা কী?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="left">ক্রম নাম্বার</TableCell>
                            <TableCell align="left">বর্ণনা</TableCell>
                            <TableCell align="left">পরিমাণ (টাকা)</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>১</TableCell>
                            <TableCell>
                              যে কোন সময়ে সর্বোচ্চ ব্যালেন্স
                            </TableCell>
                            <TableCell>৪,০০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>২</TableCell>
                            <TableCell>
                              প্রতি লেনদেনে যেকোনো চ্যানেলের মাধ্যমে অর্থ যোগ
                              করুন
                            </TableCell>
                            <TableCell>৫০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>৩</TableCell>
                            <TableCell>প্রতি মাসে টাকা যোগ করুন</TableCell>
                            <TableCell>৪,০০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>৪</TableCell>
                            <TableCell>
                              ক্রয় (ব্যক্তিগত থেকে ব্যবসায়িক)
                            </TableCell>
                            <TableCell>সীমাবদ্ধ নয়</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>৫</TableCell>

                            <TableCell colSpan={2}>
                              <Typography variant="h6">সেন্ড মানি</Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- প্রতি লেনদেনের সীমা</TableCell>
                            <TableCell>৫০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- দৈনিক সীমা </TableCell>
                            <TableCell>১,০০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- মাসিক সীমা</TableCell>
                            <TableCell>৪,০০,০০০</TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell>৬</TableCell>

                            <TableCell colSpan={2}>
                              <Typography variant="h6">
                                ব্যাংক একাউন্ট ট্রান্সফার
                              </Typography>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- প্রতি লেনদেনের সীমা</TableCell>
                            <TableCell>৫০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- দৈনিক সীমা</TableCell>
                            <TableCell>৫০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell>- মাসিক সীমা</TableCell>
                            <TableCell>৪,০০,০০০</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell colSpan={3} align="center">
                              দ্রষ্টব্য: "এসটি পে তার বিবেচনার ভিত্তিতে লেনদেনের
                              সীমা কাঠামো পরিবর্তন করার অধিকার সংরক্ষণ করে।
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* Nominee */}
              <h4>নমিনী</h4>
              <Accordion
                expanded={expanded === "panelNominee1"}
                onChange={handleChange("panelNominee1")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee1"
                  id="panel1bh-headerNominee1"
                >
                  <Typography>নমিনী বলতে কী বুঝানো হয়েছে?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    নমিনী হলো এমন একজন ব্যক্তি যাকে এস টি পেব্যবহারকারী মনোনীত করে, যার আইনগত অধিকার রয়েছে ব্যবহারকারীর মৃত্যু হওয়ার পর তার এস টি পেওয়ালেটের অবশিষ্ট তহবিল গ্রহণের।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee2"}
                onChange={handleChange("panelNominee2")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee2"
                  id="panel1bh-headerNominee2"
                >
                  <Typography>
                    এস টি পে ব্যবহারকারীর জন্য নমিনী নির্বাচন কেন গুরুত্বপূর্ণ?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    এস টি পেব্যবহারকারীর মৃত্যু হলে, তাদের মনোনীত ব্যক্তি প্রয়োজনীয় তথ্য প্রদান করে এবং নির্দিষ্ট প্রক্রিয়া অনুসরণ করে ওয়ালেটের অবশিষ্ট তহবিল উত্তোলন করতে পারবে। এজন্য এস টি পেব্যবহারকারীদের জন্য নমিনী তথ্য যোগ বা পরিবর্তনের সুবিধা দিয়েছে, যাতে তারা তাদের ওয়ালেটের নমিনী নির্বাচন করতে পারেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee3"}
                onChange={handleChange("panelNominee3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee3"
                  id="panel1bh-headerNominee3"
                >
                  <Typography>
                    নমিনী তথ্য ‘যোগ’ এবং ‘আপডেট’ বলতে কী বোঝায়?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <strong>নমিনী তথ্য যোগ</strong>: ওয়ালেটে একজন বা একাধিক ব্যক্তির তথ্য যোগ করা যাদের কাছে জাতীয় পরিচয়পত্র (NID) আছে এবং যারা মনোনীত হলে আপনার মৃত্যুর পর অবশিষ্ট তহবিল গ্রহণের যোগ্য হবেন।
                    <br />
                    <br />
                    <strong>নমিনী তথ্য আপডেট</strong>: পূর্বে যোগ করা নমিনীকে সরিয়ে নতুন একজন বৈধ NID ধারী ব্যক্তির তথ্য নমিনী হিসেবে প্রদান করা।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee4"}
                onChange={handleChange("panelNominee4")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee4"
                  id="panel1bh-headerNominee4"
                >
                  <Typography>
                    নমিনী তথ্য কে যোগ বা আপডেট করতে পারবে?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    সব সক্রিয় এস টি পেওয়ালেট ব্যবহারকারী নমিনী তথ্য যোগ বা আপডেট করতে পারবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee5"}
                onChange={handleChange("panelNominee5")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee5"
                  id="panel1bh-headerNominee5"
                >
                  <Typography>কে নমিনী হিসেবে যোগ হতে পারে?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    নিম্নলিখিত সম্পর্কযুক্ত ব্যক্তিদের নমিনীহিসেবে যোগ করা যাবে:
                    <div style={{ padding: "20px" }}>
                      <li>পিতা / মাতা / স্ত্রী / স্বামী / পুত্র / কন্যা / ভাই / বোন</li>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee6"}
                onChange={handleChange("panelNominee6")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee6"
                  id="panel1bh-headerNominee6"
                >
                  <Typography>
                    নমিনী তথ্য যোগ বা আপডেট করতে কী প্রয়োজন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    ১. আপনার সক্রিয় এস টি পেওয়ালেট নম্বর (মোবাইল নম্বর)<br />
                    ২. নমিনী-এর জাতীয় পরিচয়পত্র (NID)
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee7"}
                onChange={handleChange("panelNominee7")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee7"
                  id="panel1bh-headerNominee7"
                >
                  <Typography>
                    নমিনী তথ্য ‘সংযুক্ত’ করার পদ্ধতি কী?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    নমিনী তথ্য যোগ করতে:
                    <ol>
                      <li>অ্যাপে লগইন করুন</li>
                      <li>
                        নমিনী ইনফরমেশন অপশন নির্বাচন করুন
                      </li>
                      <li>
                        কন্টিনিউ চাপুন
                      </li>
                      <li>
                        এড / আপডেট নমিনী অপশন নির্বাচন করুন
                      </li>
                      <li>
                        নমিনী তথ্য পূরণ করুন
                        <ul>
                          <li>নাম</li>
                          <li>জাতীয় পরিচয়পত্র নম্বর</li>
                          <li>জন্ম তারিখ</li>
                          <li>নমিনী এর সঙ্গে সম্পর্ক</li>
                          <li>নমিনী ফোন নম্বর</li>
                        </ul>
                      </li>
                      <li>
                        সেভ করুন
                      </li>
                    </ol>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee8"}
                onChange={handleChange("panelNominee8")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee8"
                  id="panel1bh-headerNominee8"
                >
                  <Typography>কতজন নমিনী যোগ করা যায়?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    সর্বোচ্চ 2 জন নমিনীযোগ করা যাবে।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee9"}
                onChange={handleChange("panelNominee9")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee9"
                  id="panel1bh-headerNominee9"
                >
                  <Typography>
                    নমিনী তথ্য আপডেট করার প্রক্রিয়া কী?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    <>
                      <div className="nominee-steps">
                        পূর্বে নমিনী যোগ করার ৩০ দিনের পর নিম্নলিখিত ধাপ অনুসরণ করে নমিনী তথ্য আপডেট করা যাবে:
                        <ol>
                          <li>অ্যাপে লগইন করুন</li>
                          <li>
                            নমিনী ইনফরমেশন অপশন নির্বাচন করুন
                          </li>
                          <li>
                            কন্টিনিউ বাটন চাপুন
                          </li>
                          <li>
                            এড / আপডেট নমিনীঅপশন নির্বাচন করুন
                          </li>
                          <li>
                            নমিনী তথ্য পূরণ করুন
                            <ul>
                              <li>নাম</li>
                              <li>নমিনী-এর সঙ্গে সম্পর্ক</li>
                              <li>নমিনী-এর ফোন নম্বর</li>
                            </ul>
                          </li>
                          <li>
                            Tap <strong>Save</strong>
                          </li>
                        </ol>
                      </div>
                    </>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee10"}
                onChange={handleChange("panelNominee10")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee10"
                  id="panel1bh-headerNominee10"
                >
                  <Typography>
                    মনোনীত ব্যক্তির তথ্য কত দিন পর যোগ বা আপডেট করা যেতে পারে?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আপনি আপনার  ওয়ালেটে মনোনীত ব্যক্তির তথ্য প্রতি ৩০ দিনে একবার সফলভাবে যোগ বা আপডেট করতে পারবেন।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <Accordion
                expanded={expanded === "panelNominee11"}
                onChange={handleChange("panelNominee11")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-contentNominee11"
                  id="panel1bh-headerNominee11"
                >
                  <Typography>
                    একজন নমিনী কি অন্য কারো নমিনী হতে পারে?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আপনি যে ব্যক্তিকে নমিনী হিসেবে যোগ করেছেন, সে অন্য ব্যবহারকারীর এস টি পে ওয়ালেটে নমিনী হতে পারে। তবে, একই ব্যক্তিকে আপনি নিজের ওয়ালেটে আবার নমিনী হিসেবে যোগ করতে পারবেন না।
                  </Typography>
                </AccordionDetails>
              </Accordion>

              <h4>নিরাপত্তা</h4>
              <Accordion
                expanded={expanded === "panel32"}
                onChange={handleChange("panel32")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content32"
                  id="panel1bh-header32"
                >
                  <Typography>
                    প্রতিটি লেনদেনের আগে কি কোন পিন রাখতে হয়?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    হ্যাঁ একটি ৪-সংখ্যার পিন নম্বর রয়েছে যা যেকোনো এসটি পে
                    লেনদেনের আগে প্রয়োজন ৷ আপনার নিরাপত্তা নিশ্চিত করার জন্য।
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expanded === "panel33"}
                onChange={handleChange("panel33")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content33"
                  id="panel1bh-header33"
                >
                  <Typography>
                    এসটি পে অ্যাকাউন্টের পিন কীভাবে রিসেট করবেন?
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body2">
                    আপনার এসটি পে অ্যাকাউন্টের পিন রিসেট করতে এসটি পে অ্যাপের লগইন স্ক্রিনে থাকা <strong>Forget Pin</strong> অপশনে ট্যাপ করুন। এরপর ওটিপি ও সেলফি যাচাইকরণের মাধ্যমে আপনার পরিচয় নিশ্চিত করতে স্ক্রিনে প্রদর্শিত নির্দেশনাগুলো অনুসরণ করুন। 
                    <br/><br/>
                    পিন রিসেটের অনুরোধ জমা দেওয়ার পর আপনার তথ্য যাচাই করা হবে। এই যাচাই প্রক্রিয়া সম্পন্ন হতে সর্বোচ্চ ৪৮ ঘণ্টা সময় লাগতে পারে।
                    <br/><br/>
                    যাচাই প্রক্রিয়া সম্পন্ন হলে এসএমএস-এর মাধ্যমে আপনাকে জানিয়ে দেওয়া হবে।
                    <ul>
                      <li>
                        <strong>অনুমোদিত হলে:</strong>&nbsp;আপনার নতুন পিন ব্যবহার করে এসটি পে অ্যাকাউন্টে লগইন করতে পারবেন。
                      </li>
                      <li>
                        <strong>অনুমোদিত না হলে:</strong>&nbsp;এসএমএস-এর মাধ্যমে আপনাকে জানানো হবে। সেক্ষেত্রে আপনি পুনরায় পিন রিসেটের অনুরোধ করতে পারবেন।
                      </li>
                    </ul>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className={classes.footer}>
        <FooterBangla />
      </div>
    </>
  );
};

export default FaqBangla;
